var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadphoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_156_1059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7794 11.9548C19.0532 11.1013 19.2053 10.1864 19.2053 9.23472C19.2053 4.39018 15.3119 0.454369 10.512 0.454369C5.71222 0.454369 1.81274 4.39018 1.81274 9.24086C1.81274 10.2356 1.977 11.1934 2.28117 12.0899",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0542 20.465C16.3827 20.6123 17.1188 20.8579 17.1796 20.8825C17.6724 21.0667 18.7735 19.2738 19.6373 16.8853C20.5012 14.4968 20.7932 12.4092 20.3004 12.2311C20.2335 12.2065 19.5218 11.9179 19.175 11.8197",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.861 15.2766H17.8732C17.8732 15.2766 18.4633 13.5205 18.6762 12.2372C18.7249 11.9978 18.7492 11.8013 18.7492 11.6232C18.7675 11.2978 18.731 11.0583 18.6154 10.9601C18.6154 10.9601 18.2017 10.8127 17.7637 10.6469C17.3196 10.4812 16.1455 10.1435 14.4969 14.0363C14.3083 14.4477 14.0467 15.1476 13.8277 15.8845C12.611 19.9308 13.7243 20.4343 14.1684 20.6001C14.6125 20.7597 15.0201 20.9132 15.0201 20.9132C15.3547 20.9132 15.8535 20.0904 16.2854 19.2124C16.2854 19.2124 16.4314 18.9422 16.6748 18.3773C16.985 17.6835 17.198 17.1248 17.198 17.1248H17.1858C17.2953 16.8362 17.4109 16.5292 17.5325 16.1915C17.6542 15.8599 17.7576 15.5529 17.8489 15.2704L17.861 15.2766Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7402 21.5395C15.1174 21.5395 15.6832 20.6123 16.1698 19.6176C16.1698 19.6176 16.3341 19.3168 16.6078 18.6782C16.9546 17.8984 17.1979 17.266 17.1979 17.266H17.1858C17.3074 16.9467 17.4413 16.5967 17.5812 16.2099C17.715 15.8353 17.8367 15.4915 17.9401 15.1722H17.9523C17.9523 15.1722 18.6215 13.1951 18.8587 11.7399C18.9135 11.4697 18.9378 11.2425 18.9378 11.0522",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.94579 20.465C4.61728 20.6123 3.88119 20.8579 3.82035 20.8825C3.3276 21.0667 2.22649 19.2738 1.36265 16.8853C0.4988 14.4968 0.206796 12.4092 0.699553 12.2311C0.766471 12.2065 1.47823 11.9179 1.82499 11.8197",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.13897 15.2766H3.12681C3.12681 15.2766 2.53671 13.5205 2.32379 12.2372C2.27513 11.9978 2.25079 11.8013 2.25079 11.6232C2.23254 11.2978 2.26904 11.0583 2.38463 10.9601C2.38463 10.9601 2.7983 10.8127 3.23631 10.6469C3.6804 10.4812 4.8545 10.1435 6.50311 14.0363C6.6917 14.4477 6.95328 15.1476 7.17229 15.8845C8.38897 19.9308 7.27571 20.4343 6.83162 20.6001C6.38753 20.7597 5.97994 20.9132 5.97994 20.9132C5.64535 20.9132 5.14651 20.0904 4.71458 19.2124C4.71458 19.2124 4.56858 18.9422 4.32524 18.3773C4.01499 17.6835 3.80207 17.1248 3.80207 17.1248H3.81424C3.70473 16.8362 3.58915 16.5292 3.46748 16.1915C3.34581 15.8599 3.24239 15.5529 3.15114 15.2704L3.13897 15.2766Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25372 21.5395C5.87655 21.5395 5.31079 20.6123 4.82411 19.6176C4.82411 19.6176 4.65986 19.3168 4.38611 18.6782C4.03935 17.8984 3.79601 17.266 3.79601 17.266H3.80818C3.68651 16.9467 3.55268 16.5967 3.41276 16.2099C3.27892 15.8353 3.15725 15.4915 3.05383 15.1722H3.04167C3.04167 15.1722 2.37249 13.1951 2.13524 11.7399C2.08049 11.4697 2.05615 11.2425 2.05615 11.0522",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.22412 4.43929C3.82638 4.8998 4.8849 5.42171 6.46051 4.21211C8.03611 3.00251 9.67864 2.7262 10.2991 2.7262C10.9197 2.7262 12.5622 3.00251 14.1378 4.21211C15.7134 5.42171 16.778 4.90594 17.3803 4.43929",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_156_1059"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 22,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphoneIcon);
export default __webpack_public_path__ + "static/media/headphone-icon.2a85a8801beafff681a2496476866805.svg";
export { ForwardRef as ReactComponent };